import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";

/**
 * Phase 4.22 — Smart-Search-Button.
 * Wandelt den aktuellen Freitext-Query via Gemini in strukturierte
 * Filter-Parameter um (Marke, Modell, Jahr-Bereich, Leistung-Bereich
 * etc.) und gibt sie an `onApplyFilters` weiter.
 */
export default function SmartSearchButton({ query, onApplyFilters }) {
    const [loading, setLoading] = useState(false);

    const run = async () => {
        const q = (query || "").trim();
        if (q.length < 3) {
            toast.error("Bitte erst eine Such-Eingabe machen (mind. 3 Zeichen)");
            return;
        }
        setLoading(true);
        try {
            const r = await api.post("/search/smart-parse", { query: q });
            if (!r.data.ok) {
                toast.error("Smart-Search konnte keine Filter ableiten");
                return;
            }
            const filters = r.data.filters || {};
            const keys = Object.keys(filters);
            if (keys.length === 0) {
                toast.message("Keine Filter erkannt — bitte präziser formulieren");
                return;
            }
            onApplyFilters?.(filters);
            toast.success(`${keys.length} Filter angewendet: ${keys.join(", ")}`);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Smart-Search fehlgeschlagen");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            type="button"
            onClick={run}
            disabled={loading}
            variant="outline"
            className="rounded-sm border-2 px-3 font-bold uppercase tracking-wider text-[10px] shrink-0"
            title="KI-gestützt: Wandelt deinen Suchtext in strukturierte Filter um"
            data-testid="smart-search-btn"
        >
            {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}
            <span className="hidden sm:inline ml-1">Smart</span>
        </Button>
    );
}
